module.exports = __webpack_public_path__ + "img/1528922538.afd265a3.jpg";